export default "__VITE_PUBLIC_ASSET__c7295461__"